module.exports = "<div>\n    <div class=\"pipeline-job-modal-details-container\">\n        <h3>Property Owner</h3>\n        <p ng-bind=\"pipelineJobModal.propertyOwner\"></p>\n        <p ng-bind=\"pipelineJobModal.streetAddress\"></p>\n        <p ng-bind=\"pipelineJobModal.cityStateZip\"></p>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pipeline/job/pipelineJobDetails.html
// module id = 257
// module chunks = 1